<template>
    <div>
        <DeletedTransactions
            v-if="reportId == CREPORT.TYPE.DELETED_TRANSACTIONS"
            :data="data"
        />
        <TimeSheets v-if="reportId == CREPORT.TYPE.TIME_SHEETS" :data="data" />
    </div>
</template>
<script>
import CREPORT from "@/constants/report.js";
import DeletedTransactions from "@/module/report/module/staff/deleted-transactions";
import TimeSheets from "@/components/report-staff/time-sheets";

export default {
    components: {
        DeletedTransactions,
        TimeSheets
    },
    computed: {
        reportId() {
            return this.$route.params.id;
        }
    },
    props: {
        data: {
            default() {},
            type: Object
        }
    },
    data() {
        return { CREPORT: CREPORT };
    }
};
</script>
